const MasterDataReducer = (state = {}, action) => {
    switch (action.type) {
        case "LOOKUP_DATAS":
            return Object.assign({}, state, {
                Lookup_data: action.data
            });
        default:
            return state;
    }
};

export default MasterDataReducer;
